import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Alert, Box, Button, LinearProgress, Stack, TextField, Typography } from '@mui/material';
import { loginApi, saveToken, saveUser } from '../core/services/authService';
import { useDispatch } from 'react-redux';
import { LOGIN } from '../core/store/slice/authSlice';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '/assets/logo-sign.jpg';
import toast from 'react-hot-toast';
const validationSchema = yup.object({
    otp: yup
        .number('OTP must be a number')
        .integer('OTP must be an integer')
        .positive('OTP must be a positive number')
        // .min(1000, 'OTP must be exactly 4 digits')
        // .max(9999, 'OTP must be exactly 4 digits')
        .required('OTP is required'),
});

const OTPForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            password: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            return navigate('/reset-password');
            if (showAlert) setShowAlert(false);
            try {
                setLoading(true);

                const res = await loginApi(values.password, values.password);
                if (res?.status === 200) {
                    if (res?.data?.user?.user_type === 'admin') {
                        saveToken(res?.data?.token);
                        saveUser(res?.data);
                        dispatch(LOGIN(res?.data));
                        navigate('/');
                        toast.success(res.data.message);
                    } else if (res?.data?.user?.user_type === 'isa_agent') {
                        saveToken(res?.data?.token);
                        saveUser(res?.data);
                        dispatch(LOGIN(res?.data));
                        navigate('/');
                        toast.success(res.data.message);
                    } else {
                        return toast.error('Invalid user.');
                    }
                }
            } catch (error) {
                // setShowAlert(true);
                // setTimeout(() => {
                //     setShowAlert(false);
                // }, 3000);
                toast.error(error.message);
            } finally {
                setLoading(false);
            }
        },
    });

    const handleChange = (event) => {
        formik.handleChange(event);
        if (/^\d$/.test(event.target.value)) {
            event.target.nextSibling?.focus();
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Backspace' && !event.target.value && event.target.previousSibling) {
            event.target.previousSibling.focus();
        }
    };

    console.log(formik.errors);

    return (
        <Box height={'100vh'} width={'100vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <Box position={'relative'}>
                {showAlert && (
                    <Alert
                        sx={{ width: '50%', position: 'absolute', top: '70px', right: '0%' }}
                        severity="error"
                        onClose={() => {
                            setShowAlert(false);
                        }}
                    >
                        Email or password is incorrect.
                    </Alert>
                )}

                <Stack alignItems={'center'} direction={'row'}>
                    <Box>
                        <img width={'500px'} src={Logo} />
                    </Box>

                    <form style={{ width: '500px' }} onSubmit={formik.handleSubmit}>
                        <Stack spacing={2}>
                            {formik.errors.otp ? <div style={{ color: 'red' }}>{formik.errors.otp}</div> : null}
                            <Typography sx={{ m: 0, p: 0 }} variant="h6">
                                Please enter your otp here.
                            </Typography>
                            <small variant="h6">Check your email for otp.</small>
                            <Stack sx={{ p: 2, display: 'flex', justifyContent: 'center', bgcolor: 'lightgray' }} direction={'row'} spacing={2}>
                                {[0, 1, 2, 3].map((index) => (
                                    <input
                                        key={index}
                                        type="number"
                                        name={`otp[${index}]`}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                        value={formik?.values?.otp?.[index] || ''}
                                        maxLength={1}
                                        style={{ fontSize: '36px', width: '50px', height: '50px', marginRight: '5px' }}
                                    />
                                ))}
                            </Stack>

                            <Box>
                                <Button
                                    disabled={loading || formik.errors.otp}
                                    sx={{ borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px' }}
                                    color="success"
                                    variant="contained"
                                    fullWidth
                                    type="submit"
                                >
                                    {loading ? 'Reseting Your Password' : 'Reset Passowrd'}
                                </Button>
                                <LinearProgress sx={{ visibility: loading ? '' : 'hidden' }} />
                            </Box>
                            {/* <Link to="/forgot-password">Verify</Link> */}
                        </Stack>
                    </form>
                </Stack>
            </Box>
        </Box>
    );
};

export default OTPForm;
